import space from '../foundations/space';

const Avatar = {
   parts: ['container', 'label'],
   sizes: {
      md: {
         container: {
            height: space[9],
            width: space[9],
         },
         label: {
            fontSize: '90%',
         },
      },
   },
};

export default Avatar;
